export const formatPrice = (number) => {
  return new Intl.NumberFormat('en-TN', {
    style: 'currency',
    currency: 'TND',
    maximumFractionDigits : 0
  }).format(number);
 
};

export const formatAddress = (data) => {
  const { address, city, state, country, pinCode } = data;
  return `${address}, ${city}, ${state} - ${pinCode}, ${country}`;
};

export const getOrderStatusColor = (status) => {
  if (status === 'processing') {
    return 'orange';
  }
  if (status === 'rejected') {
    return 'red';
  }
  return 'green';
};

export const getAdminPrivilegeColor = (privilege) => {
  if (privilege === 'super') {
    return 'green';
  }
  if (privilege === 'moderate') {
    return 'blue';
  }
  if (privilege === 'low') {
    return 'brown';
  }
};

// axios only populates error.response when the server actually replied with
// an HTTP status. A network-level failure (server unreachable, offline, CORS
// block, timeout) leaves error.response undefined — reading .data off it
// crashes instead of showing an error message, which is what left the login
// button stuck mid-spinner instead of reporting the failure.
export const getApiError = (error) => {
  if (error.response && error.response.data) {
    return error.response.data;
  }
  return {
    success: false,
    message: 'Network error — please check your connection and try again.',
  };
};

export const getSecureUrl = (url) => {
  if (url && url.startsWith('http://')) {
    return url.replace('http://', 'https://');
  }
  return url;
};

// Ask Cloudinary for a resized/auto-compressed version instead of shipping
// the full-resolution original for a small thumbnail.
export const getThumbnailUrl = (url, size = 200) => {
  const secureUrl = getSecureUrl(url);
  if (!secureUrl || !secureUrl.includes('/upload/')) {
    return secureUrl;
  }
  return secureUrl.replace('/upload/', `/upload/w_${size},h_${size},c_fill,q_auto,f_auto/`);
};
